// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"35c3072a","703":"1d7d5270","729":"2458a4b2","787":"bfaced0d"}[chunkId] + ".chunk.js";
};